<!-- Card -->
<competition-add-member-card
  [role]="role"
  (onSubmit)="onFormSubmit($event)"
  [isSubmitButtonDisabled]="isSubmitButtonDisabled"
></competition-add-member-card>
